<div class="navigation back-button">
	<div class="inner">
		<a class="back-link" (click)="location.back()">Back</a>
	</div>
</div>
